const countryCodes = {
  AF: { value: 'AF', phone: '+93' },
  AL: { value: 'AL', phone: '+355' },
  DZ: { value: 'DZ', phone: '+213' },
  AS: { value: 'AS', phone: '+1684' },
  AD: { value: 'AD', phone: '+376' },
  AO: { value: 'AO', phone: '+244' },
  AI: { value: 'AI', phone: '+1264' },
  AQ: { value: 'AQ', phone: '+672' },
  AG: { value: 'AG', phone: '+1268' },
  AR: { value: 'AR', phone: '+54' },
  AM: { value: 'AM', phone: '+374' },
  AW: { value: 'AW', phone: '+297' },
  AU: { value: 'AU', phone: '+61' },
  AT: { value: 'AT', phone: '+43' },
  AZ: { value: 'AZ', phone: '+994' },
  BS: { value: 'BS', phone: '+1242' },
  BH: { value: 'BH', phone: '+973' },
  BD: { value: 'BD', phone: '+880' },
  BB: { value: 'BB', phone: '+1246' },
  BY: { value: 'BY', phone: '+375' },
  BE: { value: 'BE', phone: '+32' },
  BZ: { value: 'BZ', phone: '+501' },
  BJ: { value: 'BJ', phone: '+229' },
  BM: { value: 'BM', phone: '+1441' },
  BT: { value: 'BT', phone: '+975' },
  BO: { value: 'BO', phone: '+591' },
  BA: { value: 'BA', phone: '+387' },
  BW: { value: 'BW', phone: '+267' },
  BV: { value: 'BV', phone: '+47' },
  BR: { value: 'BR', phone: '+55' },
  IO: { value: 'IO', phone: '+246' },
  BN: { value: 'BN', phone: '+673' },
  BG: { value: 'BG', phone: '+359' },
  BF: { value: 'BF', phone: '+226' },
  BI: { value: 'BI', phone: '+257' },
  KH: { value: 'KH', phone: '+855' },
  CM: { value: 'CM', phone: '+237' },
  CA: { value: 'CA', phone: '+1' },
  CV: { value: 'CV', phone: '+238' },
  KY: { value: 'KY', phone: '+1345' },
  CF: { value: 'CF', phone: '+236' },
  TD: { value: 'TD', phone: '+235' },
  CL: { value: 'CL', phone: '+56' },
  CN: { value: 'CN', phone: '+86' },
  CX: { value: 'CX', phone: '+61' },
  CC: { value: 'CC', phone: '+61' },
  CO: { value: 'CO', phone: '+57' },
  KM: { value: 'KM', phone: '+269' },
  CG: { value: 'CG', phone: '+242' },
  CD: { value: 'CD', phone: '+243' },
  CK: { value: 'CK', phone: '+682' },
  CR: { value: 'CR', phone: '+506' },
  CI: { value: 'CI', phone: '+225' },
  HR: { value: 'HR', phone: '+385' },
  CU: { value: 'CU', phone: '+53' },
  CY: { value: 'CY', phone: '+357' },
  CZ: { value: 'CZ', phone: '+420' },
  DK: { value: 'DK', phone: '+45' },
  DJ: { value: 'DJ', phone: '+253' },
  DM: { value: 'DM', phone: '+1767' },
  DO: { value: 'DO', phone: '+1809' },
  EC: { value: 'EC', phone: '+593' },
  EG: { value: 'EG', phone: '+20' },
  SV: { value: 'SV', phone: '+503' },
  GQ: { value: 'GQ', phone: '+240' },
  ER: { value: 'ER', phone: '+291' },
  EE: { value: 'EE', phone: '+372' },
  ET: { value: 'ET', phone: '+251' },
  FK: { value: 'FK', phone: '+500' },
  FO: { value: 'FO', phone: '+298' },
  FJ: { value: 'FJ', phone: '+679' },
  FI: { value: 'FI', phone: '+358' },
  FR: { value: 'FR', phone: '+33' },
  GF: { value: 'GF', phone: '+594' },
  PF: { value: 'PF', phone: '+689' },
  GA: { value: 'GA', phone: '+241' },
  GM: { value: 'GM', phone: '+220' },
  GE: { value: 'GE', phone: '+995' },
  DE: { value: 'DE', phone: '+49' },
  GH: { value: 'GH', phone: '+233' },
  GI: { value: 'GI', phone: '+350' },
  GR: { value: 'GR', phone: '+30' },
  GL: { value: 'GL', phone: '+299' },
  GD: { value: 'GD', phone: '+1473' },
  GP: { value: 'GP', phone: '+590' },
  GU: { value: 'GU', phone: '+1671' },
  GT: { value: 'GT', phone: '+502' },
  GN: { value: 'GN', phone: '+224' },
  GW: { value: 'GW', phone: '+245' },
  GY: { value: 'GY', phone: '+592' },
  HT: { value: 'HT', phone: '+509' },
  HM: { value: 'HM', phone: '+672' },
  VA: { value: 'VA', phone: '+379' },
  HN: { value: 'HN', phone: '+504' },
  HK: { value: 'HK', phone: '+852' },
  HU: { value: 'HU', phone: '+36' },
  IS: { value: 'IS', phone: '+354' },
  IN: { value: 'IN', phone: '+91' },
  ID: { value: 'ID', phone: '+62' },
  IR: { value: 'IR', phone: '+98' },
  IQ: { value: 'IQ', phone: '+964' },
  IE: { value: 'IE', phone: '+353' },
  IL: { value: 'IL', phone: '+972' },
  IT: { value: 'IT', phone: '+39' },
  JM: { value: 'JM', phone: '+1876' },
  JP: { value: 'JP', phone: '+81' },
  JO: { value: 'JO', phone: '+962' },
  KZ: { value: 'KZ', phone: '+7' },
  KE: { value: 'KE', phone: '+254' },
  KI: { value: 'KI', phone: '+686' },
  KP: { value: 'KP', phone: '+850' },
  KR: { value: 'KR', phone: '+82' },
  KW: { value: 'KW', phone: '+965' },
  KG: { value: 'KG', phone: '+996' },
  LA: { value: 'LA', phone: '+856' },
  LV: { value: 'LV', phone: '+371' },
  LB: { value: 'LB', phone: '+961' },
  LS: { value: 'LS', phone: '+266' },
  LR: { value: 'LR', phone: '+231' },
  LY: { value: 'LY', phone: '+218' },
  LI: { value: 'LI', phone: '+423' },
  LT: { value: 'LT', phone: '+370' },
  LU: { value: 'LU', phone: '+352' },
  MO: { value: 'MO', phone: '+853' },
  MK: { value: 'MK', phone: '+389' },
  MG: { value: 'MG', phone: '+261' },
  MW: { value: 'MW', phone: '+265' },
  MY: { value: 'MY', phone: '+60' },
  MV: { value: 'MV', phone: '+960' },
  ML: { value: 'ML', phone: '+223' },
  MT: { value: 'MT', phone: '+356' },
  MH: { value: 'MH', phone: '+692' },
  MQ: { value: 'MQ', phone: '+596' },
  MR: { value: 'MR', phone: '+222' },
  MU: { value: 'MU', phone: '+230' },
  YT: { value: 'YT', phone: '+262' },
  MX: { value: 'MX', phone: '+52' },
  FM: { value: 'FM', phone: '+691' },
  MD: { value: 'MD', phone: '+373' },
  MC: { value: 'MC', phone: '+377' },
  MN: { value: 'MN', phone: '+976' },
  MS: { value: 'MS', phone: '+1664' },
  MA: { value: 'MA', phone: '+212' },
  MZ: { value: 'MZ', phone: '+258' },
  MM: { value: 'MM', phone: '+95' },
  NA: { value: 'NA', phone: '+264' },
  NR: { value: 'NR', phone: '+674' },
  NP: { value: 'NP', phone: '+977' },
  NL: { value: 'NL', phone: '+31' },
  AN: { value: 'AN', phone: '+599' },
  NC: { value: 'NC', phone: '+687' },
  NZ: { value: 'NZ', phone: '+64' },
  NI: { value: 'NI', phone: '+505' },
  NE: { value: 'NE', phone: '+227' },
  NG: { value: 'NG', phone: '+234' },
  NU: { value: 'NU', phone: '+683' },
  NF: { value: 'NF', phone: '+672' },
  MP: { value: 'MP', phone: '+1670' },
  NO: { value: 'NO', phone: '+47' },
  OM: { value: 'OM', phone: '+968' },
  PK: { value: 'PK', phone: '+92' },
  PW: { value: 'PW', phone: '+680' },
  PS: { value: 'PS', phone: '+970' },
  PA: { value: 'PA', phone: '+507' },
  PG: { value: 'PG', phone: '+675' },
  PY: { value: 'PY', phone: '+595' },
  PE: { value: 'PE', phone: '+51' },
  PH: { value: 'PH', phone: '+63' },
  PN: { value: 'PN', phone: '+64' },
  PL: { value: 'PL', phone: '+48' },
  PT: { value: 'PT', phone: '+351' },
  PR: { value: 'PR', phone: '+1787' },
  QA: { value: 'QA', phone: '+974' },
  RE: { value: 'RE', phone: '+262' },
  RO: { value: 'RO', phone: '+40' },
  RU: { value: 'RU', phone: '+7' },
  RW: { value: 'RW', phone: '+250' },
  SH: { value: 'SH', phone: '+290' },
  KN: { value: 'KN', phone: '+1869' },
  LC: { value: 'LC', phone: '+1758' },
  PM: { value: 'PM', phone: '+508' },
  VC: { value: 'VC', phone: '+1784' },
  WS: { value: 'WS', phone: '+685' },
  SM: { value: 'SM', phone: '+378' },
  ST: { value: 'ST', phone: '+239' },
  SA: { value: 'SA', phone: '+966' },
  SN: { value: 'SN', phone: '+221' },
  CS: { value: 'CS', phone: '+381' },
  SC: { value: 'SC', phone: '+248' },
  SL: { value: 'SL', phone: '+232' },
  SG: { value: 'SG', phone: '+65' },
  SK: { value: 'SK', phone: '+421' },
  SI: { value: 'SI', phone: '+386' },
  SB: { value: 'SB', phone: '+677' },
  SO: { value: 'SO', phone: '+252' },
  ZA: { value: 'ZA', phone: '+27' },
  GS: { value: 'GS', phone: '+500' },
  ES: { value: 'ES', phone: '+34' },
  LK: { value: 'LK', phone: '+94' },
  SD: { value: 'SD', phone: '+249' },
  SR: { value: 'SR', phone: '+597' },
  SJ: { value: 'SJ', phone: '+47' },
  SZ: { value: 'SZ', phone: '+268' },
  SE: { value: 'SE', phone: '+46' },
  CH: { value: 'CH', phone: '+41' },
  SY: { value: 'SY', phone: '+963' },
  TW: { value: 'TW', phone: '+886' },
  TJ: { value: 'TJ', phone: '+992' },
  TZ: { value: 'TZ', phone: '+255' },
  TH: { value: 'TH', phone: '+66' },
  TL: { value: 'TL', phone: '+670' },
  TG: { value: 'TG', phone: '+228' },
  TK: { value: 'TK', phone: '+690' },
  TO: { value: 'TO', phone: '+676' },
  TT: { value: 'TT', phone: '+1868' },
  TN: { value: 'TN', phone: '+216' },
  TR: { value: 'TR', phone: '+90' },
  TM: { value: 'TM', phone: '+993' },
  TC: { value: 'TC', phone: '+1649' },
  TV: { value: 'TV', phone: '+688' },
  UG: { value: 'UG', phone: '+256' },
  UA: { value: 'UA', phone: '+380' },
  AE: { value: 'AE', phone: '+971' },
  GB: { value: 'GB', phone: '+44' },
  US: { value: 'US', phone: '+1' },
  UM: { value: 'UM', phone: '+1' },
  UY: { value: 'UY', phone: '+598' },
  UZ: { value: 'UZ', phone: '+998' },
  VU: { value: 'VU', phone: '+678' },
  VE: { value: 'VE', phone: '+58' },
  VN: { value: 'VN', phone: '+84' },
  VG: { value: 'VG', phone: '+1284' },
  VI: { value: 'VI', phone: '+1340' },
  WF: { value: 'WF', phone: '+681' },
  YE: { value: 'YE', phone: '+967' },
  ZM: { value: 'ZM', phone: '+260' },
  ZW: { value: 'ZW', phone: '+263' },
};

export default countryCodes;
